import { OrderStateEnum } from '@bo-client/shared/models/orderRequestDto';
import { StatusDefinition } from '../status.model';

/** Hausanschluss – Auftragsstatus je Sparte (`Order.state`); ohne eigene Farben. */
export const ORDERS_STATUS_DEFINITIONS: readonly StatusDefinition[] = [
  { value: OrderStateEnum.Created, defaultLabel: 'Nicht angelegt' },
  { value: OrderStateEnum.Placed, defaultLabel: 'Offen' },
  { value: OrderStateEnum.CreatingSap, defaultLabel: 'Auftrag in Erstellung (SAP)' },
  { value: OrderStateEnum.ConfirmationRequestedByMail, defaultLabel: 'Angebot per E-Mail versandt' },
  { value: OrderStateEnum.Confirmed, defaultLabel: 'Angebot bestätigt' },
  { value: OrderStateEnum.ErrorCreatingOrder, defaultLabel: 'Fehler bei der Auftragsanlage' },
  { value: OrderStateEnum.Approved, defaultLabel: 'Freigegeben' },
  { value: OrderStateEnum.UnderConstruction, defaultLabel: 'Im Bau' },
  { value: OrderStateEnum.InProgress, defaultLabel: 'In Bearbeitung' },
  { value: OrderStateEnum.TechnicallyCompleted, defaultLabel: 'Technisch abgeschlossen' },
  { value: OrderStateEnum.CommerciallyCompleted, defaultLabel: 'Kaufmännisch abgeschlossen' },
  { value: OrderStateEnum.Canceled, defaultLabel: 'Storniert' }
];
